// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__aQXGf","contentWrapper":"styles_contentWrapper__wHfnl","text":"styles_text__l5SbR","link":"styles_link__UhXZt","heading":"styles_heading__iuMV7"};